import { set, uniq, update } from "lodash-es"
const useErrors = ({ schema, state }): any => {
  if (!schema) return [{}]
  try {
    schema.validateSync(state, { abortEarly: false })
    return [{}]
  } catch ({ inner, errors }) {
    let errorMap = {
      latest: "",
      details: {},
      total: 0,
    }
    inner &&
      inner.forEach(innerError => {
        set(errorMap.details, innerError.path, innerError.message)
      })
    set(errorMap, "total", errors?.length)
    set(errorMap, "latest", errors?.[0])
    return [errorMap]
  }
}

function getErrors({ schema, state, abortEarly = false, ...otherParams }): any {
  try {
    schema.validateSync(state, { abortEarly, ...otherParams })
    return {}
  } catch (data) {
    let errorMap = {
      latest: "",
      details: {},
      list: [],
      total: 0,
    }
    data &&
      data.inner &&
      data.inner.forEach(innerError => {
        set(errorMap.details, innerError.path, innerError.message)
        update(errorMap, "list", list => uniq(list.concat(innerError.message)))
      })
    set(errorMap, "total", data?.errors?.length)
    set(errorMap, "latest", data?.errors?.[0])
    return errorMap
  }
}
export default useErrors
export { getErrors }
